import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../../Environment/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HpaServiceService {
  baseurl:string="";
  constructor(private http:HttpClient ) { 
    this.baseurl = environment.apiUrl;
  }

  public getUnitVersion():Observable<any>{
    return this.http.get<any[]>(this.baseurl + 'HPA/GetUnitVersion');
  }

  public getInputType():Observable<any>{
    return this.http.get<any[]>(this.baseurl + 'HPA/GetTypeofUnit');
  }
  
  public getOutputShaft(size:any):Observable<any>{
    const url = `${this.baseurl}HPA/GetOutputShaftDia?size=${size}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getMotorAdaptor(inputType:any,size:any):Observable<any>{
    const url = `${this.baseurl}HPA/GetMotorAdaptor?TypeOfUnit=${inputType}&size=${size} `;
    return this.http.get(url).pipe(map((response:any)=>response));
  }

  public getAssemblyPosition(unitVersion:any):Observable<any>{
    const url = `${this.baseurl}HPA/GetAssemblyPosition?UnitVersion=${unitVersion}`;
    return this.http.get<any[]>(url).pipe(map((response:any)=> response));
  }
  // public getSpecialFeatures():Observable<any>{
  //   return this.http.get(this.baseurl+'HPA/GetSpecialFeature');
  // }
  public getSpecialFeatures(dutyCycle:any,series:any):Observable<any>{
    const url = `${this.baseurl}HPA/GetSpecialFeature?dutyCycle=${dutyCycle}&series=${series} `;
    return this.http.get(url).pipe(map((response:any)=>response));
  }
public getSpecification(request:any):Observable<any>{
  const httpParams = new HttpParams({fromObject:request});
  const headers = new HttpHeaders({'Content-Type':'application/json'});
  return this.http.get(this.baseurl+'HPA/GetSpecification',{
    params:httpParams,
    headers:headers,
    observe:'response',
    responseType:'json'
  });
}
  public getLargerReducer(request:any):Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'HPA/GetLargerReducer',{
      params:httpParams,
      headers:headers,
      observe:'response',
      responseType:'json'
    });
  }
  public getSmallerReducer(request:any):Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'HPA/GetSmallerReducer',{
    params:httpParams,
    headers:headers,
    observe:'response',
    responseType:'json'
    });
  }
}
